
import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import {Checkbox} from '@carbon/react';
import { Edit, TrashCan } from '@carbon/react/icons';


// DATOS MUESTRA ----------
/*
const rows = [{
    id: '1',
    nombre: 'Recibos nómina',
    consultar: <Checkbox labelText="" id={"chk-" + 1} checked={true} />,
    agregar: <Checkbox labelText="" id={"chk-" + 2} checked={false} />,
    modificar: <Checkbox labelText="" id={"chk-" + 3} checked={false} />,
    eliminar: <Checkbox labelText="" id={"chk-" + 4} checked={false} />,
  }
];
*/
//------------------------

const headers = [
    { name: <div>ID</div>, selector: rows=>rows['id'], width: '80px', wrap: true  },
    { name: <div>MÓDULO</div>, selector: rows=>rows['nombre'], width: '220px', wrap: true  },
    { name: <div>CONSULTAR</div>, selector: rows=>rows['consultar'], wrap: true  },
    { name: <div>AGREGAR</div>, selector: rows=>rows['agregar'], wrap: true  },
    { name: <div>MODIFICAR</div>, selector: rows=>rows['modificar'], wrap: true  },
    { name: <div>ELIMINAR</div>, selector: rows=>rows['eliminar'], wrap: true  },
];

const PermisosTable = ({ rows }) => {

    const [filteredRows, setFilteredRows] = useState(rows);

    useEffect(() => {
        setFilteredRows(rows);
    }, [rows]);

    const handleSearch = (value) => {
        const filteredData = rows.filter((row) => {
            return Object.values(row).some((val) =>
                String(val).toLowerCase().includes(value.toLowerCase())
            );
        });

        setFilteredRows(filteredData);
    };

    return (

        <DataTable
            title=""
            columns={headers}
            data={filteredRows}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
            highlightOnHover
             /*
            subHeader
            subHeaderComponent={
                <input
                    type="text"
                    className='busqueda'
                    placeholder="BÚSQUEDA"
                    onChange={(e) => handleSearch(e.target.value)}
                />
            }
            */
            noDataComponent="No hay datos disponibles"
            paginationComponentOptions={{
                rowsPerPageText: 'Filas por página:',
                rangeSeparatorText: 'de',
                noRowsPerPageText: 'Sin filas por página',
            }}
        />
    );
};

export default PermisosTable;